import { useMapLayers } from './useMapLayers';

// TODO(m.kania): fix types
export const useClusterMap = () =>
  useMapLayers({
    select: (s) => s.group,
  });
